import { useEffect, useRef, useState } from 'react';
import { Container } from './styles';

export function SaveTheDate() {
    const [timerDays, setTimerDays] = useState('00');
    const [timerHours, setTimerHours] = useState('00');
    const [timerMinutes, setTimerMinutes] = useState('00');
    const [timerSeconds, setTimerSeconds] = useState('00');

    let interval = useRef();

    const startTimer = () => {
        const countdownDate = new Date('Mar 5, 2022 00:00:00').getTime();

        interval = setInterval(() => {
            const now = new Date().getTime();
            const distance = now - countdownDate;

            const days = Math.floor(distance / (1000 * 60 * 60 * 24));
            const hours = Math.floor((distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)));
            const minutes = Math.floor((distance % (1000 * 60 * 60) / (1000 * 60)));
            const seconds = Math.floor((distance % (1000 * 60)) / 1000);

            if (distance < 0) {
                clearInterval(interval.current);
            } else {
                setTimerDays(days);
                setTimerHours(hours);
                setTimerMinutes(minutes);
                setTimerSeconds(seconds);
            }
        }, 1000)
    }

    useEffect(() => {
        startTimer();
        return () => {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            clearInterval(interval.current);
        }
    })

    return (
        <Container>
            <div className="timerContainer">
                <h1>O Grande Dia</h1>
                <span>05.03.2022</span>
                <h2>Casados há</h2>
                <div className="countTimers">
                    <div className="count">
                        <p className="number">
                            {timerDays}
                        </p>
                        <p className="text">Dias</p>
                    </div>
                    <span>:</span>
                    <div className="count">
                        <p className="number">
                            {timerHours}
                        </p>
                        <p className="text">Horas</p>
                    </div>
                    <span>:</span>
                    <div className="count">
                        <p className="number">
                            {timerMinutes}
                        </p>
                        <p className="text">Minutos</p>
                    </div>
                    <span>:</span>
                    <div className="count">
                        <p className="number">
                            {timerSeconds}
                        </p>
                        <p className="text">Segundos</p>
                    </div>
                </div>
            </div>
        </Container>
    );
}
